// M01 數系與近似值 - 練習題數據 (主題 6-10)
// 系統化設計，準備後續 Supabase 數據遷移
// 每個主題 10 題，共 50 題

// ========== 6. 百分誤差公式 (10題) ==========
export const M01_06_PROBLEMS = [
  {
    id: 'M01_06_P001',
    topicId: 'M01_06',
    question: "測量值為 52.3 cm，真實值為 50.0 cm，計算百分誤差",
    solution: "4.6%",
    explanation: "百分誤差 = |(測量值 - 真實值) / 真實值| × 100% = |(52.3 - 50.0) / 50.0| × 100% = 4.6%",
    hint: "百分誤差公式：|(測量值 - 真實值) / 真實值| × 100%",
    difficulty: 2,
    order: 1,
    steps: ["百分誤差 = |(測量值 - 真實值) / 真實值| × 100%", "= |(52.3 - 50.0) / 50.0| × 100%", "= 4.6%"]
  },
  {
    id: 'M01_06_P002',
    topicId: 'M01_06',
    question: "實驗測得重力加速度為 9.75 m/s²，標準值為 9.8 m/s²，求百分誤差",
    solution: "0.51%",
    explanation: "百分誤差 = |(9.75 - 9.8) / 9.8| × 100% = 0.51%",
    hint: "重力加速度的精確測量",
    difficulty: 2,
    order: 2,
    steps: ["百分誤差 = |(9.75 - 9.8) / 9.8| × 100%", "= |(-0.05) / 9.8| × 100%", "= 0.51%"]
  },
  {
    id: 'M01_06_P003',
    topicId: 'M01_06',
    question: "電阻器標示為 1000 Ω，測量值為 1050 Ω，計算百分誤差",
    solution: "5.0%",
    explanation: "百分誤差 = |(1050 - 1000) / 1000| × 100% = 5.0%",
    hint: "電阻器的誤差通常用百分比表示",
    difficulty: 1,
    order: 3,
    steps: ["百分誤差 = |(1050 - 1000) / 1000| × 100%", "= |50 / 1000| × 100%", "= 5.0%"]
  },
  {
    id: 'M01_06_P004',
    topicId: 'M01_06',
    question: "溫度計讀數為 98.2°F，體溫應為 98.6°F，求百分誤差",
    solution: "0.41%",
    explanation: "百分誤差 = |(98.2 - 98.6) / 98.6| × 100% = 0.41%",
    hint: "體溫測量的精確度要求",
    difficulty: 2,
    order: 4,
    steps: ["百分誤差 = |(98.2 - 98.6) / 98.6| × 100%", "= |(-0.4) / 98.6| × 100%", "= 0.41%"]
  },
  {
    id: 'M01_06_P005',
    topicId: 'M01_06',
    question: "天平稱重 245 g，物品實際重量 250 g，計算百分誤差",
    solution: "2.0%",
    explanation: "百分誤差 = |(245 - 250) / 250| × 100% = 2.0%",
    hint: "天平測量的準確性",
    difficulty: 1,
    order: 5,
    steps: ["百分誤差 = |(245 - 250) / 250| × 100%", "= |(-5) / 250| × 100%", "= 2.0%"]
  },
  {
    id: 'M01_06_P006',
    topicId: 'M01_06',
    question: "速度表顯示 62 km/h，GPS顯示 60 km/h，求百分誤差",
    solution: "3.33%",
    explanation: "百分誤差 = |(62 - 60) / 60| × 100% = 3.33%",
    hint: "以GPS讀數為標準值",
    difficulty: 2,
    order: 6,
    steps: ["百分誤差 = |(62 - 60) / 60| × 100%", "= |2 / 60| × 100%", "= 3.33%"]
  },
  {
    id: 'M01_06_P007',
    topicId: 'M01_06',
    question: "電壓表讀數 11.8 V，標準電壓 12.0 V，計算百分誤差",
    solution: "1.67%",
    explanation: "百分誤差 = |(11.8 - 12.0) / 12.0| × 100% = 1.67%",
    hint: "電壓測量的精度",
    difficulty: 2,
    order: 7,
    steps: ["百分誤差 = |(11.8 - 12.0) / 12.0| × 100%", "= |(-0.2) / 12.0| × 100%", "= 1.67%"]
  },
  {
    id: 'M01_06_P008',
    topicId: 'M01_06',
    question: "測量長度為 2.03 m，實際長度為 2.00 m，求百分誤差",
    solution: "1.5%",
    explanation: "百分誤差 = |(2.03 - 2.00) / 2.00| × 100% = 1.5%",
    hint: "長度測量的誤差分析",
    difficulty: 1,
    order: 8,
    steps: ["百分誤差 = |(2.03 - 2.00) / 2.00| × 100%", "= |0.03 / 2.00| × 100%", "= 1.5%"]
  },
  {
    id: 'M01_06_P009',
    topicId: 'M01_06',
    question: "頻率測量值 50.2 Hz，標準頻率 50.0 Hz，計算百分誤差",
    solution: "0.4%",
    explanation: "百分誤差 = |(50.2 - 50.0) / 50.0| × 100% = 0.4%",
    hint: "頻率測量通常要求高精度",
    difficulty: 2,
    order: 9,
    steps: ["百分誤差 = |(50.2 - 50.0) / 50.0| × 100%", "= |0.2 / 50.0| × 100%", "= 0.4%"]
  },
  {
    id: 'M01_06_P010',
    topicId: 'M01_06',
    question: "密度測量值 0.98 g/cm³，理論值 1.00 g/cm³，求百分誤差",
    solution: "2.0%",
    explanation: "百分誤差 = |(0.98 - 1.00) / 1.00| × 100% = 2.0%",
    hint: "密度測量的相對誤差",
    difficulty: 2,
    order: 10,
    steps: ["百分誤差 = |(0.98 - 1.00) / 1.00| × 100%", "= |(-0.02) / 1.00| × 100%", "= 2.0%"]
  }
];

// ========== 7. 誤差界限分析 (10題) ==========
export const M01_07_PROBLEMS = [
  {
    id: 'M01_07_P001',
    topicId: 'M01_07',
    question: "測量值為 25.3 ± 0.2 cm，求誤差界限的範圍",
    solution: "25.1 cm 到 25.5 cm",
    explanation: "誤差界限範圍 = 測量值 ± 誤差界限 = 25.3 ± 0.2 cm",
    hint: "誤差界限表示測量值的可能範圍",
    difficulty: 1,
    order: 1,
    steps: ["下界限 = 25.3 - 0.2 = 25.1 cm", "上界限 = 25.3 + 0.2 = 25.5 cm", "範圍：25.1 cm 到 25.5 cm"]
  },
  {
    id: 'M01_07_P002',
    topicId: 'M01_07',
    question: "重量測量為 150 ± 3 g，計算相對誤差界限",
    solution: "2.0%",
    explanation: "相對誤差界限 = (誤差界限 / 測量值) × 100% = (3 / 150) × 100% = 2.0%",
    hint: "相對誤差界限用百分比表示",
    difficulty: 2,
    order: 2,
    steps: ["相對誤差界限 = (誤差界限 / 測量值) × 100%", "= (3 / 150) × 100%", "= 2.0%"]
  },
  {
    id: 'M01_07_P003',
    topicId: 'M01_07',
    question: "電壓測量 12.0 ± 0.5 V，求最大可能值和最小可能值",
    solution: "最大：12.5 V，最小：11.5 V",
    explanation: "最大值 = 12.0 + 0.5 = 12.5 V，最小值 = 12.0 - 0.5 = 11.5 V",
    hint: "誤差界限決定測量值的範圍",
    difficulty: 1,
    order: 3,
    steps: ["最大可能值 = 12.0 + 0.5 = 12.5 V", "最小可能值 = 12.0 - 0.5 = 11.5 V"]
  },
  {
    id: 'M01_07_P004',
    topicId: 'M01_07',
    question: "長度測量 5.2 ± 0.1 m，寬度測量 3.0 ± 0.1 m，求面積的誤差界限",
    solution: "面積：15.6 ± 1.1 m²",
    explanation: "面積 = 5.2 × 3.0 = 15.6 m²，誤差傳播：Δ面積 ≈ |3.0 × 0.1| + |5.2 × 0.1| = 0.3 + 0.52 ≈ 0.8 m²",
    hint: "乘法運算的誤差傳播",
    difficulty: 3,
    order: 4,
    steps: ["面積 = 5.2 × 3.0 = 15.6 m²", "誤差傳播：Δ面積 ≈ |∂面積/∂長度| × Δ長度 + |∂面積/∂寬度| × Δ寬度", "≈ |3.0 × 0.1| + |5.2 × 0.1| = 0.82 m²"]
  },
  {
    id: 'M01_07_P005',
    topicId: 'M01_07',
    question: "時間測量 2.5 ± 0.1 s，求相對誤差界限（百分比）",
    solution: "4.0%",
    explanation: "相對誤差界限 = (0.1 / 2.5) × 100% = 4.0%",
    hint: "時間測量的精度要求",
    difficulty: 2,
    order: 5,
    steps: ["相對誤差界限 = (誤差界限 / 測量值) × 100%", "= (0.1 / 2.5) × 100%", "= 4.0%"]
  },
  {
    id: 'M01_07_P006',
    topicId: 'M01_07',
    question: "溫度測量 25 ± 2°C，如果要求誤差界限不超過 1°C，是否滿足要求？",
    solution: "不滿足，誤差界限為 2°C > 1°C",
    explanation: "測量的誤差界限是 ±2°C，超過了要求的 ±1°C",
    hint: "比較實際誤差界限與要求",
    difficulty: 1,
    order: 6,
    steps: ["實際誤差界限：±2°C", "要求誤差界限：±1°C", "2°C > 1°C，不滿足要求"]
  },
  {
    id: 'M01_07_P007',
    topicId: 'M01_07',
    question: "壓力測量 100 ± 5 kPa，計算測量值的信賴區間",
    solution: "95 kPa 到 105 kPa",
    explanation: "信賴區間 = 測量值 ± 誤差界限 = 100 ± 5 kPa",
    hint: "信賴區間表示真實值可能存在的範圍",
    difficulty: 2,
    order: 7,
    steps: ["下界 = 100 - 5 = 95 kPa", "上界 = 100 + 5 = 105 kPa", "信賴區間：95 kPa 到 105 kPa"]
  },
  {
    id: 'M01_07_P008',
    topicId: 'M01_07',
    question: "電流測量 2.0 ± 0.2 A，電阻測量 10 ± 1 Ω，求功率的誤差界限",
    solution: "功率：40 ± 8 W",
    explanation: "功率 P = I²R = 2.0² × 10 = 40 W，相對誤差：ΔP/P ≈ 2(ΔI/I) + (ΔR/R) = 2(0.2/2.0) + (1/10) = 0.3，所以 ΔP ≈ 40 × 0.3 = 12 W",
    hint: "功率計算的誤差傳播",
    difficulty: 3,
    order: 8,
    steps: ["功率 P = I²R = 4 × 10 = 40 W", "相對誤差：ΔP/P ≈ 2(ΔI/I) + (ΔR/R)", "≈ 2(0.2/2.0) + (1/10) = 0.3", "ΔP ≈ 40 × 0.3 = 12 W"]
  },
  {
    id: 'M01_07_P009',
    topicId: 'M01_07',
    question: "速度測量 50 ± 3 km/h，時間測量 2.0 ± 0.1 h，求距離的誤差界限",
    solution: "距離：100 ± 8 km",
    explanation: "距離 = 速度 × 時間 = 50 × 2.0 = 100 km，相對誤差：Δd/d ≈ (Δv/v) + (Δt/t) = (3/50) + (0.1/2.0) = 0.11，所以 Δd ≈ 100 × 0.11 = 11 km",
    hint: "乘法運算的相對誤差相加",
    difficulty: 3,
    order: 9,
    steps: ["距離 = 50 × 2.0 = 100 km", "相對誤差：Δd/d ≈ (Δv/v) + (Δt/t)", "≈ (3/50) + (0.1/2.0) = 0.11", "Δd ≈ 100 × 0.11 = 11 km"]
  },
  {
    id: 'M01_07_P010',
    topicId: 'M01_07',
    question: "質量測量 500 ± 10 g，如果要將相對誤差界限控制在 1% 以內，誤差界限應該是多少？",
    solution: "±5 g",
    explanation: "要求相對誤差界限 ≤ 1%，即 (誤差界限 / 500) × 100% ≤ 1%，所以誤差界限 ≤ 500 × 0.01 = 5 g",
    hint: "從相對誤差要求推算絕對誤差界限",
    difficulty: 2,
    order: 10,
    steps: ["相對誤差界限 = (誤差界限 / 測量值) × 100%", "要求：≤ 1%", "誤差界限 ≤ 500 × 0.01 = 5 g"]
  }
];

// ========== 8. 有效數字規則 (10題) ==========
export const M01_08_PROBLEMS = [
  {
    id: 'M01_08_P001',
    topicId: 'M01_08',
    question: "在乘法運算中，如果一個數有3個有效數字，另一個數有4個有效數字，結果應該保留幾個有效數字？",
    solution: "3個有效數字",
    explanation: "乘法和除法運算中，結果的有效數字個數由參與運算的數中有效數字最少的決定",
    hint: "乘除法取最少有效數字",
    difficulty: 1,
    order: 1,
    steps: ["第一個數：3個有效數字", "第二個數：4個有效數字", "結果：取較少的，即3個有效數字"]
  },
  {
    id: 'M01_08_P002',
    topicId: 'M01_08',
    question: "計算 12.34 + 5.6 + 0.789，按有效數字規則給出答案",
    solution: "18.7",
    explanation: "加法運算中，結果的小數位數由參與運算的數中小數位數最少的決定。5.6只有1位小數",
    hint: "加減法看小數位數",
    difficulty: 2,
    order: 2,
    steps: ["12.34 + 5.6 + 0.789 = 18.729", "5.6只有1位小數", "結果保留1位小數：18.7"]
  },
  {
    id: 'M01_08_P003',
    topicId: 'M01_08',
    question: "判斷 0.00506 有多少個有效數字",
    solution: "3個有效數字",
    explanation: "前導零不是有效數字，5, 0, 6 都是有效數字",
    hint: "前導零只是佔位符",
    difficulty: 1,
    order: 3,
    steps: ["0.00506", "前面的0不算有效數字", "5, 0, 6 是有效數字，共3個"]
  },
  {
    id: 'M01_08_P004',
    topicId: 'M01_08',
    question: "計算 (2.5 × 10³) ÷ (1.25 × 10²)，按有效數字規則給出答案",
    solution: "2.0 × 10¹ 或 20",
    explanation: "除法運算：(2.5 ÷ 1.25) × (10³ ÷ 10²) = 2.0 × 10¹，兩數都有2-3個有效數字，結果保留2個有效數字",
    hint: "科學記數法的除法",
    difficulty: 2,
    order: 4,
    steps: ["2.5 ÷ 1.25 = 2.0", "10³ ÷ 10² = 10¹", "結果：2.0 × 10¹，保留2個有效數字"]
  },
  {
    id: 'M01_08_P005',
    topicId: 'M01_08',
    question: "判斷 1200 有幾個有效數字（不用科學記數法）",
    solution: "不確定，可能是2個、3個或4個",
    explanation: "末尾的零可能是有效數字也可能不是，需要額外信息確定",
    hint: "末尾零的歧義性",
    difficulty: 2,
    order: 5,
    steps: ["1200", "末尾的0可能有效也可能無效", "需要科學記數法或其他方式明確"]
  },
  {
    id: 'M01_08_P006',
    topicId: 'M01_08',
    question: "計算 π × 2.5（π ≈ 3.14159），按有效數字規則給出答案",
    solution: "7.9",
    explanation: "2.5有2個有效數字，π取足夠精度，結果保留2個有效數字",
    hint: "常數的有效數字處理",
    difficulty: 2,
    order: 6,
    steps: ["π × 2.5 ≈ 3.14159 × 2.5 = 7.8540", "2.5有2個有效數字", "結果：7.9"]
  },
  {
    id: 'M01_08_P007',
    topicId: 'M01_08',
    question: "在測量中得到 25.00 cm，這個數有幾個有效數字？",
    solution: "4個有效數字",
    explanation: "小數點後的零表示測量精度，都是有效數字",
    hint: "小數點後的零是有效的",
    difficulty: 1,
    order: 7,
    steps: ["25.00 cm", "小數點後的0表示精度", "2, 5, 0, 0 都是有效數字，共4個"]
  },
  {
    id: 'M01_08_P008',
    topicId: 'M01_08',
    question: "計算 √(16.0)，按有效數字規則給出答案",
    solution: "4.00",
    explanation: "16.0有3個有效數字，√16 = 4，結果應保留3個有效數字",
    hint: "開方運算的有效數字",
    difficulty: 2,
    order: 8,
    steps: ["√(16.0) = 4", "16.0有3個有效數字", "結果：4.00（3個有效數字）"]
  },
  {
    id: 'M01_08_P009',
    topicId: 'M01_08',
    question: "計算 100 - 99.5，按有效數字規則給出答案",
    solution: "0.5 或 1",
    explanation: "如果100是精確值，結果是0.5；如果100只有1個有效數字，結果不確定性很大",
    hint: "整數的有效數字問題",
    difficulty: 3,
    order: 9,
    steps: ["100 - 99.5 = 0.5", "100的有效數字不明確", "需要更多信息確定結果精度"]
  },
  {
    id: 'M01_08_P010',
    topicId: 'M01_08',
    question: "科學記數法 3.0 × 10⁵ 有幾個有效數字？",
    solution: "2個有效數字",
    explanation: "科學記數法中，有效數字由係數部分決定，3.0有2個有效數字",
    hint: "科學記數法的係數決定有效數字",
    difficulty: 1,
    order: 10,
    steps: ["3.0 × 10⁵", "係數：3.0", "3.0有2個有效數字"]
  }
];

// ========== 9. 加法有效數字處理 (10題) ==========
export const M01_09_PROBLEMS = [
  {
    id: 'M01_09_P001',
    topicId: 'M01_09',
    question: "計算 12.5 + 3.47 + 0.123，按有效數字規則給出答案",
    solution: "16.1",
    explanation: "加法中，結果的小數位數由最少小數位數決定。12.5只有1位小數",
    hint: "加法看小數位數，取最少的",
    difficulty: 2,
    order: 1,
    steps: ["12.5 + 3.47 + 0.123 = 16.093", "12.5只有1位小數", "結果保留1位小數：16.1"]
  },
  {
    id: 'M01_09_P002',
    topicId: 'M01_09',
    question: "計算 245.6 + 12 + 0.789，按有效數字規則給出答案",
    solution: "258",
    explanation: "12沒有小數位，所以結果應該是整數",
    hint: "整數沒有小數位",
    difficulty: 2,
    order: 2,
    steps: ["245.6 + 12 + 0.789 = 258.389", "12沒有小數位", "結果：258（整數）"]
  },
  {
    id: 'M01_09_P003',
    topicId: 'M01_09',
    question: "計算 0.0025 + 0.147 + 2.3，按有效數字規則給出答案",
    solution: "2.4",
    explanation: "2.3只有1位小數，決定了結果的小數位數",
    hint: "最少小數位數決定結果",
    difficulty: 2,
    order: 3,
    steps: ["0.0025 + 0.147 + 2.3 = 2.4495", "2.3只有1位小數", "結果：2.4"]
  },
  {
    id: 'M01_09_P004',
    topicId: 'M01_09',
    question: "計算 100.0 + 25.67 + 3.456，按有效數字規則給出答案",
    solution: "129.1",
    explanation: "100.0有1位小數，決定了結果的精度",
    hint: "100.0表示精確到十分位",
    difficulty: 2,
    order: 4,
    steps: ["100.0 + 25.67 + 3.456 = 129.126", "100.0有1位小數", "結果：129.1"]
  },
  {
    id: 'M01_09_P005',
    topicId: 'M01_09',
    question: "計算 5.6 + 12.34 - 3.789，按有效數字規則給出答案",
    solution: "14.2",
    explanation: "5.6只有1位小數，是最少的小數位數",
    hint: "加減混合運算同樣看小數位數",
    difficulty: 2,
    order: 5,
    steps: ["5.6 + 12.34 - 3.789 = 14.151", "5.6只有1位小數", "結果：14.2"]
  },
  {
    id: 'M01_09_P006',
    topicId: 'M01_09',
    question: "計算 0.50 + 0.123 + 0.0067，按有效數字規則給出答案",
    solution: "0.63",
    explanation: "0.50有2位小數，是最少的小數位數",
    hint: "0.50的精度到百分位",
    difficulty: 2,
    order: 6,
    steps: ["0.50 + 0.123 + 0.0067 = 0.6297", "0.50有2位小數", "結果：0.63"]
  },
  {
    id: 'M01_09_P007',
    topicId: 'M01_09',
    question: "計算 1000 + 25.6 + 3.45，如果1000是精確值，按有效數字規則給出答案",
    solution: "1029.1",
    explanation: "如果1000是精確值，不限制精度，由25.6的1位小數決定",
    hint: "精確值不影響有效數字",
    difficulty: 3,
    order: 7,
    steps: ["1000（精確值）+ 25.6 + 3.45 = 1029.05", "25.6有1位小數", "結果：1029.1"]
  },
  {
    id: 'M01_09_P008',
    topicId: 'M01_09',
    question: "計算 π + 2.5 + 1.23（π取足夠精度），按有效數字規則給出答案",
    solution: "6.9",
    explanation: "2.5只有1位小數，決定結果精度",
    hint: "常數π可以取任意精度",
    difficulty: 2,
    order: 8,
    steps: ["π + 2.5 + 1.23 ≈ 3.14159 + 2.5 + 1.23 = 6.87159", "2.5有1位小數", "結果：6.9"]
  },
  {
    id: 'M01_09_P009',
    topicId: 'M01_09',
    question: "計算 45.67 - 12.1 + 0.234，按有效數字規則給出答案",
    solution: "33.8",
    explanation: "12.1只有1位小數，是最少的",
    hint: "減法也遵循同樣規則",
    difficulty: 2,
    order: 9,
    steps: ["45.67 - 12.1 + 0.234 = 33.804", "12.1只有1位小數", "結果：33.8"]
  },
  {
    id: 'M01_09_P010',
    topicId: 'M01_09',
    question: "計算 0.0012 + 1.5 + 23.456，按有效數字規則給出答案",
    solution: "25.0",
    explanation: "1.5只有1位小數，決定結果精度",
    hint: "不同數量級的數相加",
    difficulty: 2,
    order: 10,
    steps: ["0.0012 + 1.5 + 23.456 = 24.9572", "1.5只有1位小數", "結果：25.0"]
  }
];

// ========== 10. 有效數字解釋 (10題) ==========
export const M01_10_PROBLEMS = [
  {
    id: 'M01_10_P001',
    topicId: 'M01_10',
    question: "解釋為什麼在測量中，有效數字很重要？",
    solution: "有效數字反映測量的精度和可靠性，避免給出超過測量精度的虛假精確度",
    explanation: "有效數字表示測量結果中可信的數字位數，超出有效數字的位數是不可靠的",
    hint: "有效數字與測量精度直接相關",
    difficulty: 1,
    order: 1,
    steps: ["有效數字表示測量精度", "避免虛假精確度", "保證結果的可靠性"]
  },
  {
    id: 'M01_10_P002',
    topicId: 'M01_10',
    question: "為什麼 0.0450 和 0.045 的有效數字個數不同？",
    solution: "0.0450有3個有效數字，0.045有2個有效數字。末尾的0表示測量精度",
    explanation: "0.0450中的末尾0表示測量精確到萬分位，而0.045只精確到千分位",
    hint: "末尾零表示測量精度",
    difficulty: 2,
    order: 2,
    steps: ["0.0450：4, 5, 0 都是有效數字", "0.045：4, 5 是有效數字", "末尾0表示精度不同"]
  },
  {
    id: 'M01_10_P003',
    topicId: 'M01_10',
    question: "解釋為什麼乘法運算中，結果的有效數字由最少的決定？",
    solution: "因為最不精確的數限制了整個計算結果的精度",
    explanation: "在乘法中，相對誤差會累積，最不精確的數決定了結果的精度上限",
    hint: "最弱環節決定整體精度",
    difficulty: 2,
    order: 3,
    steps: ["相對誤差會傳播", "最不精確的數限制精度", "避免過度精確的結果"]
  },
  {
    id: 'M01_10_P004',
    topicId: 'M01_10',
    question: "為什麼加法運算看小數位數而不是有效數字個數？",
    solution: "因為加法中，絕對誤差會累積，小數位數反映絕對精度",
    explanation: "加法運算中，各數的絕對誤差相加，結果的精度由絕對精度最低的數決定",
    hint: "加法看絕對精度，乘法看相對精度",
    difficulty: 3,
    order: 4,
    steps: ["加法中絕對誤差累積", "小數位數反映絕對精度", "結果精度由最低絕對精度決定"]
  },
  {
    id: 'M01_10_P005',
    topicId: 'M01_10',
    question: "解釋科學記數法如何幫助明確有效數字？",
    solution: "科學記數法的係數部分明確顯示所有有效數字，消除末尾零的歧義",
    explanation: "例如：3.00 × 10⁵ 明確有3個有效數字，而300000的有效數字不明確",
    hint: "係數部分顯示有效數字",
    difficulty: 2,
    order: 5,
    steps: ["係數部分包含所有有效數字", "消除末尾零的歧義", "明確表示測量精度"]
  },
  {
    id: 'M01_10_P006',
    topicId: 'M01_10',
    question: "為什麼前導零不算有效數字？",
    solution: "前導零只是佔位符，用來表示數的大小，不反映測量精度",
    explanation: "例如0.00123中的前導零只是定位小數點，真正的測量值是123（在合適的單位下）",
    hint: "前導零只是佔位符",
    difficulty: 1,
    order: 6,
    steps: ["前導零只是佔位符", "不反映測量精度", "只用來定位小數點"]
  },
  {
    id: 'M01_10_P007',
    topicId: 'M01_10',
    question: "解釋為什麼精確值（如π、e等常數）不限制有效數字？",
    solution: "精確值可以取任意精度，不會引入額外誤差，不限制計算結果的精度",
    explanation: "精確值本身沒有測量誤差，可以根據需要取足夠的精度參與計算",
    hint: "精確值沒有測量誤差",
    difficulty: 2,
    order: 7,
    steps: ["精確值沒有測量誤差", "可以取任意需要的精度", "不限制結果精度"]
  },
  {
    id: 'M01_10_P008',
    topicId: 'M01_10',
    question: "為什麼在報告測量結果時要包含不確定度？",
    solution: "不確定度表示測量結果的可信範圍，是科學測量的完整表述",
    explanation: "例如：(25.3 ± 0.2) cm 比單純的 25.3 cm 提供更多信息",
    hint: "不確定度表示測量可信範圍",
    difficulty: 2,
    order: 8,
    steps: ["不確定度表示可信範圍", "完整的科學表述", "幫助評估結果可靠性"]
  },
  {
    id: 'M01_10_P009',
    topicId: 'M01_10',
    question: "解釋為什麼計算器給出的所有數字不都是有效數字？",
    solution: "計算器顯示的數字可能超出輸入數據的精度，多餘的數字是無意義的",
    explanation: "計算器不理解有效數字概念，會顯示所有計算結果，需要人工判斷有效性",
    hint: "計算器不理解測量精度",
    difficulty: 2,
    order: 9,
    steps: ["計算器顯示所有計算結果", "可能超出輸入精度", "需要人工判斷有效性"]
  },
  {
    id: 'M01_10_P010',
    topicId: 'M01_10',
    question: "解釋有效數字與精確度、準確度的關係",
    solution: "有效數字反映精確度（重現性），準確度關乎與真實值的接近程度，兩者相互獨立",
    explanation: "可以有高精確度但低準確度（系統誤差），或高準確度但低精確度（隨機誤差大）",
    hint: "精確度和準確度是不同概念",
    difficulty: 3,
    order: 10,
    steps: ["有效數字反映精確度", "準確度關乎真實值", "兩者相互獨立", "系統誤差vs隨機誤差"]
  }
]; 